import RegisterServiceCard from 'TenantModule/components/Management/RegisterServiceCard';
import RegisterNewServiceCard from 'TenantModule/components/Management/RegisterNewServiceCard';
import { CreateTenantCard } from 'TenantModule/components/Management/CreateTenantCard';
import { CohortManagementCard } from 'TenantModule/components/Management/CohortManagementCard';
import { Grid, Typography } from '@mui/material';
import { TenantSecretMappingCard } from 'TenantModule/components/Management/TenantSecretMappingCard';
import StandardPageHeader from 'components/StandardPageHeader';
import { CreateSubscriptionRealmCard } from 'RealmModule/components/SubscriptionRealm/CreateSubscriptionRealmCard';
import { AddServiceToRealmCard } from 'RealmModule/components/SubscriptionRealm/AddServiceToRealmCard';
import { InitializeSubscriptionRealmCard } from 'RealmModule/components/SubscriptionRealm/InitializeSubscriptionRealmCard';
import { PageContainer } from 'components/styled';
import { Helmet } from 'react-helmet-async';

const TenantAndRealmManagementPage = () => {
  return (
    <PageContainer>
      <Helmet title="Tenant & Realm Management" />
      <Grid
        container
        spacing={3}
        sx={{
          alignItems: 'stretch',
        }}
      >
        <Grid size={12}>
          <StandardPageHeader title="Tenant & Realm Management" icon="Realm" sx={{ mb: 4 }} />
        </Grid>

        <Grid size={12}>
          <Typography variant="h6" component="h3" sx={{ fontWeight: 600, mb: 1 }}>
            Tenant Management
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <CreateTenantCard />
        </Grid>
        {/* Wider span: the cohort card renders a five-column capacity table that
            does not fit a one-third column. */}
        <Grid size={{ xs: 12, lg: 8 }}>
          <CohortManagementCard />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <RegisterNewServiceCard />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <RegisterServiceCard />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <TenantSecretMappingCard />
        </Grid>

        <Grid size={12}>
          <Typography variant="h6" component="h3" sx={{ fontWeight: 600, mt: 2 }}>
            Realm Management
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <CreateSubscriptionRealmCard />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <AddServiceToRealmCard />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <InitializeSubscriptionRealmCard />
        </Grid>
      </Grid>
    </PageContainer>
  );
};

export default TenantAndRealmManagementPage;
